import { graphql } from '../generated';

export const CONNECT_CLAUDE_CODE = graphql(`
  mutation ConnectClaudeCode($input: ConnectClaudeCodeInput!) {
    connectClaudeCode(input: $input) {
      connection {
        status
        environmentName
        keyHint
        connectedAt
        lastSessionAt
        rejectedAt
      }
      userErrors {
        code
        field
        message
      }
    }
  }
`);

export const DISCONNECT_CLAUDE_CODE = graphql(`
  mutation DisconnectClaudeCode {
    disconnectClaudeCode {
      connection {
        status
      }
      userErrors {
        code
        message
      }
    }
  }
`);

export const START_CODEX_CONNECTION = graphql(`
  mutation StartCodexConnection {
    startCodexConnection {
      connection {
        status
        webhookUrl
        secretHint
        lastEventType
        lastEventAt
      }
      userErrors {
        code
        message
      }
    }
  }
`);

export const REVEAL_CODEX_SECRET = graphql(`
  mutation RevealCodexSecret {
    revealCodexSecret {
      secret
      userErrors {
        code
        message
      }
    }
  }
`);

export const ROTATE_CODEX_SECRET = graphql(`
  mutation RotateCodexSecret {
    rotateCodexSecret {
      connection {
        status
        webhookUrl
        secretHint
      }
      userErrors {
        code
        message
      }
    }
  }
`);

export const DISCONNECT_CODEX = graphql(`
  mutation DisconnectCodex {
    disconnectCodex {
      connection {
        status
      }
      userErrors {
        code
        message
      }
    }
  }
`);
